import { put, takeLatest, all } from "redux-saga/effects";
import { requestGraphQL } from "../../../../js/utils/requests";
import * as action from "../actions";
import { services, constants } from "../service";

export function* getFaqFeedbackRequest(config) {
  const { id } = config;
  try {
    const response = yield requestGraphQL(services.getFaqFeedback(id));
    if (response && response.status >= 200 && response.status < 300) {
      const data = response.data?.data?.faqFeedback;
      yield put(action.getFaqFeedbackSuccess(data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.getFaqFeedbackError(error));
  }
}

export function* getFaqFeedbackWatcher() {
  yield takeLatest(constants.GET_FAQ_FEEDBACK, getFaqFeedbackRequest);
}

export function* setFaqFeedbackRequest(config) {
  const { id, isGood } = config;
  try {
    const response = yield requestGraphQL(services.setFaqFeedback(id, isGood));
    if (response && response.status >= 200 && response.status < 300) {
      const data = response.data?.data?.createFaqFeedback?.faqFeedback;
      yield put(action.setFaqFeedbackSuccess(data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.setFaqFeedbackError(error));
  }
}

export function* setFaqFeedbackWatcher() {
  yield takeLatest(constants.SET_FAQ_FEEDBACK, setFaqFeedbackRequest);
}

export default function* defaultSaga() {
  yield all([getFaqFeedbackWatcher(), setFaqFeedbackWatcher()]);
}
